export default __webpack_public_path__ + "static/media/logo-dibk.f5906a74.svg";